module.exports = __webpack_public_path__ + "img/HC1020-112.eeaaa8f6.jpg";